export const baseStyle = {
  fontFamily: 'Mono Bold',
  strokeThickness: 3,
  fontSize: '20px',
  stroke: '#fff',
  fill: '#000',
};
